import { Routes, Route } from "react-router-dom";

import ShraddhaAdminUser from "../AdminPages/Admin/AdminUser";
import ShraddhaAdminEvent from "../AdminPages/Academy/AdminEvent";
import ShraddhaAdminTraning from "../AdminPages/Academy/TrainingVideos";
import ShraddhaInfiniteMember from "../AdminPages/Admin/InfiniteMember";
import AdminCourses from "../AdminPages/Academy/AdminCourses";
import VideoResourses from "../AdminPages/Academy/VideoResourses";
import AdminDashBoard from "../AdminPages/Admin/AdminDashBoard";
import UserSearch from "../AdminPages/Admin/UserSearch"

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/VideoResourses" element={<VideoResourses />} />
      <Route path="/AdminDashBoard" element={<AdminDashBoard />} />
      <Route path="/ShraddhaAdminUser" element={<ShraddhaAdminUser />} />
      <Route path="/ShraddhaAdminEvent" element={<ShraddhaAdminEvent />} />
      <Route path="/AdminCourses" element={<AdminCourses />} />
      <Route path="/ShraddhaAdminTraning" element={<ShraddhaAdminTraning />} />
      <Route path="/ShraddhaInfiniteMember"element={<ShraddhaInfiniteMember />}/>
      <Route path="/UserSearch"element={<UserSearch />}/>
    
    </Routes>
  );
};

export default AdminRoutes;
